var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsNumber, IsObject, IsString, ValidateNested } from 'class-validator';
export const TREATMENT_PLAN_TASK_IDS = [
    'plan_expiring_soon',
    'treatment_start_due',
    'treatment_interruption',
    'missing_appointments',
    'unbilled_units_remaining',
    'copay_outstanding',
    'gkv_submission_due',
    'outstanding_cancellation_fee',
    'catalog_deviations',
    'pending_booking_confirmation',
];
export class TaskScopeDto {
    type;
    id;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], TaskScopeDto.prototype, "type", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], TaskScopeDto.prototype, "id", void 0);
export class TreatmentPlanTaskViewDto {
    id;
    severity;
    // Plain pass-through. The shape is a discriminated union keyed on `id`;
    // class-transformer cannot type-narrow that, and a wrapper class with no
    // decorated properties strips the contents at serialization time.
    params;
    scope;
    occurrenceKey;
    ruleVersion;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], TreatmentPlanTaskViewDto.prototype, "id", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], TreatmentPlanTaskViewDto.prototype, "severity", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentPlanTaskViewDto.prototype, "params", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => TaskScopeDto),
    Expose(),
    __metadata("design:type", TaskScopeDto)
], TreatmentPlanTaskViewDto.prototype, "scope", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], TreatmentPlanTaskViewDto.prototype, "occurrenceKey", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentPlanTaskViewDto.prototype, "ruleVersion", void 0);
//# sourceMappingURL=treatment-plan-task-view.dto.js.map